import React from 'react';
import { Box, Typography } from '@mui/material';

interface BoxTextFieldType {
  title: string | number;
  value: string | number;
  backgroundColor1?: 'transparent' | 'var(--C11A16)' | 'var(--A71414)';
  backgroundColor2?: 'transparent' | 'var(--C11A16)' | 'var(--A71414)';
  fontSize?: string;
  isAboveSlider?: boolean;
}

interface BoxTextFieldWrapper {
  children: React.ReactNode;
}

const BoxTextFieldWrapper = ({ children }: BoxTextFieldWrapper) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {children}
    </Box>
  );
};

const BoxTextField = ({
  title,
  value,
  backgroundColor1,
  backgroundColor2,
  fontSize,
  isAboveSlider,
}: BoxTextFieldType) => {
  return (
    <BoxTextFieldWrapper>
      {backgroundColor1 ? (
        <Box
          sx={{
            minWidth: 66,
            minHeight: 42,
            backgroundColor: backgroundColor1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '12px',
          }}
        >
          <Typography
            sx={(theme) => ({
              [theme.breakpoints.up('xs')]: {
                fontSize: fontSize ?? '13px',
              },
              [theme.breakpoints.up('sm')]: {
                fontSize: fontSize ?? '16px',
              },
              [theme.breakpoints.up('md')]: {
                fontSize: fontSize ?? '24px',
              },
              [theme.breakpoints.up('lg')]: {
                fontSize: fontSize ?? '20px',
              },
            })}
          >
            {title}
          </Typography>
        </Box>
      ) : (
        <Typography
          sx={(theme) => ({
            [theme.breakpoints.up('xs')]: {
              fontSize: fontSize ?? '13px',
            },
            [theme.breakpoints.up('sm')]: {
              fontSize: fontSize ?? '16px',
            },
            [theme.breakpoints.up('md')]: {
              fontSize: fontSize ?? '24px',
            },
            [theme.breakpoints.up('lg')]: {
              fontSize: fontSize ?? '20px',
            },
          })}
        >
          {title}
        </Typography>
      )}
      <Box
        sx={{
          minWidth: backgroundColor1 ? 66 : 152,
          minHeight: backgroundColor1 ? 42 : 58,
          backgroundColor: backgroundColor2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '12px',
        }}
      >
        <Typography
          sx={(theme) => ({
            fontWeight: isAboveSlider ? 700 : 600,

            [theme.breakpoints.up('xs')]: {
              fontSize: fontSize ?? '13px',
            },
            [theme.breakpoints.up('sm')]: {
              fontSize: fontSize ?? '16px',
            },
            [theme.breakpoints.up('md')]: {
              fontSize: fontSize ?? '24px',
            },
            [theme.breakpoints.up('lg')]: {
              fontSize: fontSize ?? '20px',
            },
          })}
        >
          {value}
        </Typography>
      </Box>
    </BoxTextFieldWrapper>
  );
};

export default BoxTextField;
